// extracted by mini-css-extract-plugin
export default {"cls1":"usePaperAttachment-cls1___ff7422fa0ec081c4461","cls2":"usePaperAttachment-cls2___ace4d4750567d9406bb usePaperAttachment-cls1___ff7422fa0ec081c4461"};